import { faXmark } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import { useAppDispatch, useAppSelector } from "../../redux/Store";
import { hideHintModal, hintModalSelector } from "../../redux/slice/HintModalSlice";
import FASvgIcon from "../FASvgIcon";
import {
  EmployerTANHint,
  ExemptAllowancesHint,
  FDRD26ASHint,
  FDRDInterestCertificateHint,
  FYPriorConstructionHint,
  GrossSalary171Hint,
  GrossSalaryHint,
  HRAAllowanceHint,
  HRAExemptAllowanceHint,
  IFSCCodeHint,
  InterestPaidPostConstructionHint,
  InterestPaidPreConstructionHint,
  Investment80CHint,
  LTAAllowanceHint,
  MunicipalTaxHint,
  OtherAssetsHint,
  Perquisites172Hint,
  ProfitsInLieu173Hint,
  PropertyTypeHint,
  Relief89Hint,
  RetirementBenefitsNonNCHint,
  SavingsInterestCertificateHint,
  SavingsInterestStatementHint,
  Section57Hint,
  Section89ANCHint,
  TotalTDSHint
} from "../hints";

type Props = {};

const HintModal: React.FC<Props> = (props: Props) => {
  const dispatch = useAppDispatch();
  const { show, title, componentName } = useAppSelector(hintModalSelector);

  const handleModalClose = () => {
    dispatch(hideHintModal());
  };

  const renderChildren: { [key: string]: any } = {
    "IFSCCodeHint": <IFSCCodeHint />,
    "EmployerTANHint": <EmployerTANHint />,
    "TotalTDSHint": <TotalTDSHint />,
    "GrossSalaryHint": <GrossSalaryHint />,
    "GrossSalary171Hint": <GrossSalary171Hint />,
    "HRAAllowanceHint": <HRAAllowanceHint />,
    "LTAAllowanceHint": <LTAAllowanceHint />,
    "Perquisites172Hint": <Perquisites172Hint />,
    "ProfitsInLieu173Hint": <ProfitsInLieu173Hint />,
    "Section89ANCHint": <Section89ANCHint />,
    "ExemptAllowancesHint": <ExemptAllowancesHint />,
    "Relief89Hint": <Relief89Hint />,
    "OtherAssetsHint": <OtherAssetsHint />,
    "HRAExemptAllowanceHint": <HRAExemptAllowanceHint />,
    "Investment80CHint": <Investment80CHint />,
    "Section57Hint": <Section57Hint />,
    "RetirementBenefitsNonNCHint": <RetirementBenefitsNonNCHint />,
    "SavingsInterestCertificateHint": <SavingsInterestCertificateHint />,
    "SavingsInterestStatementHint": <SavingsInterestStatementHint />,
    "FDRD26ASHint": <FDRD26ASHint />,
    "FDRDInterestCertificateHint": <FDRDInterestCertificateHint />,
    "FYPriorConstructionHint": <FYPriorConstructionHint />,
    "InterestPaidPostConstructionHint": <InterestPaidPostConstructionHint />,
    "InterestPaidPreConstructionHint": <InterestPaidPreConstructionHint />,
    "MunicipalTaxHint": <MunicipalTaxHint />,
    "PropertyTypeHint": <PropertyTypeHint />
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleModalClose}
        centered
        backdrop="static"
        className="hint-modal"
      >
        <Button variant="primary" className="icon-only close-modal" onClick={handleModalClose}>
          <FASvgIcon icon={faXmark} />
        </Button>
        {title && (
          <Modal.Header className="justify-content-start">
            <Modal.Title className="h3">{title}</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body className={classNames(!title && "pt-4")}>
          {renderChildren[componentName]}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HintModal;
